import React from 'react'

import styles from './BoxTitle.scss';

const BoxTitle = (props) => {
	let classNames = styles.boxTitle
  let customStyles = {}


	if(props.type == 'nopadding'){
		classNames = classNames + ' ' + styles.noPadding
	}

  if(props.ellipsis){
    classNames = classNames + ' ' + styles.ellipsis
    customStyles = {width: props.ellipsis}
  }

  if(props.small) {
    classNames = classNames + ' ' + styles.isSmall    
  }


  return (
  		<h2 
          className={classNames}
          style={customStyles}>
          {props.children}
        </h2>
  )
}

export default BoxTitle



// WEBPACK FOOTER //
// ./src/components/atoms/BoxTitle/index.js